import { useCallback, useState } from "react";
import {
  selectIsLocalVideoEnabled,
  selectLocalPeer,
  useHMSActions,
  useHMSStore,
} from "@100mslive/react-sdk";
import { useLiveSettingsActions } from "../../store";

export const useHMSCamera = () => {
  const [isCameraPending, setIsCameraPending] = useState(false);
  const [cameraError, setCameraError] = useState<string | null>(null);
  const hmsActions = useHMSActions();
  const isCameraEnabled = useHMSStore(selectIsLocalVideoEnabled);
  const { setCameraEnabled } = useLiveSettingsActions();
  const localPeer = useHMSStore(selectLocalPeer);
  const isLocalVideoReady = !!localPeer?.videoTrack;

  const toggleCamera = useCallback(async () => {
    try {
      if (isLocalVideoReady) {
        setIsCameraPending(true);
        await hmsActions.setLocalVideoEnabled(!isCameraEnabled);
        setCameraEnabled(!isCameraEnabled);
        setCameraError(null);
      }
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : "";
      setCameraError(errorMessage);
      console.error("Could not toggle camera: ", errorMessage);
    } finally {
      setIsCameraPending(false);
    }
  }, [
    isCameraEnabled,
    isLocalVideoReady,
    hmsActions,
    setCameraEnabled,
    setCameraError,
  ]);

  return {
    isCameraEnabled,
    isCameraPending: !isLocalVideoReady || isCameraPending,
    cameraError,
    toggleCamera,
  };
};
